import { render, staticRenderFns } from "./ZCbuliangzichanbaoxingzhizhanbi2.vue?vue&type=template&id=2a2bacac&scoped=true"
import script from "./ZCbuliangzichanbaoxingzhizhanbi2.vue?vue&type=script&lang=js"
export * from "./ZCbuliangzichanbaoxingzhizhanbi2.vue?vue&type=script&lang=js"
import style0 from "./ZCbuliangzichanbaoxingzhizhanbi2.vue?vue&type=style&index=0&id=2a2bacac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2bacac",
  null
  
)

export default component.exports